import { useQuery } from '@tanstack/react-query';
import { getDocs, orderBy, query } from 'firebase/firestore';

import { useAuth } from '@/app/auth';
import { sensorsCollection } from '@/lib/firestorePaths';

import type { Sensor } from '../types/sensor';

const STALE_TIME_MS = 30_000;
const REFETCH_INTERVAL_MS = 60_000;

export const sensorsQueryKey = (homeId: string | undefined) => ['homeAutomation', 'sensors', homeId ?? null] as const;

export default function useSensors(homeId: string | undefined) {
  const { status } = useAuth();
  const enabled = status === 'authorized' && !!homeId;

  return useQuery<Sensor[]>({
    queryKey: sensorsQueryKey(homeId),
    queryFn: async () => {
      const snap = await getDocs(query(sensorsCollection(homeId!), orderBy('name')));
      return snap.docs.map((d) => ({ id: d.id, ...d.data() }));
    },
    enabled,
    staleTime: STALE_TIME_MS,
    refetchInterval: enabled ? REFETCH_INTERVAL_MS : false,
  });
}
